import React from "react";

const withChildren = (children, Component) => props => (
  <Component {...props}>{children}</Component>
);

export default withChildren;
